import { gql } from '@apollo/client';

import { TRANSACTION_FRAGMENT } from '../fragments';

export const CREATE_ONE_TIME_DEPOSIT = gql`
  ${TRANSACTION_FRAGMENT}
  mutation createOneTimeDeposit(
    $goalId: String!
    $bankAccountId: String
    $amountInCents: Int!
    $executionDate: Date!
  ) {
    createOneTimeDeposit(
      input: {
        goalId: $goalId
        bankAccountId: $bankAccountId
        amountInCents: $amountInCents
        executionDate: $executionDate
      }
    ) {
      ...TransactionFragment
    }
  }
`;
